var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DefaultTemplate',{attrs:{"title":_vm.$t('resetPassword.header'),"subtitle":"","steps":false}},[_c('ResetPassword')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }